import { toast } from "react-toastify";

export default function notify(message){
    toast(message);
}